import React, { useEffect, useState } from 'react'
import { Badge, Col, Row } from 'reactstrap'
import logo from "../../assets/images/dofy-logo-blue.png"
import { countrycodenumber, currencyByCountry, getCountryCodeStorage, isIn, loadConfigforImageApiUrl, toAmount } from '../../helpers/Helper'
import { HelperConstant } from '../../helpers/HelperConstant'
import moment from 'moment'
import { IStatusModel } from 'models/StatusModel'
import { IGetOrderSummaryModel } from 'models/GetOrderSummary.Model'
import CommonService from 'services/CommonService'
import Delay from 'components/reportdelay/Delay'
import { OrderPayout } from './OrderPayout'
import { useNavigate } from 'react-router-dom'

const CustomerInfo = ({ orderSummaryInfo, showEdit }: any) => {
    let navigate = useNavigate();
    const [cdnUrl, setCdnUrl] = useState("");
    const [showToast, setShowToast] = useState(false);
    const [isReferral, setIsReferral] = useState<boolean>(false);
    const [showModal, setShowModal] = useState(false);
    const [InrAmount, setInrAmount] = useState<{ Amount: number }>({ Amount: 0 });

    const [statusToDisplay, setStatusToDisplay] = useState<IStatusModel[]>();
    const [OrderSummaryInfo, setOrderSummaryInfo] = useState<IGetOrderSummaryModel>({} as IGetOrderSummaryModel);
    const [isOpen, setIsOpen] = useState(false);

    const toINR = (aed: number, rate: number) => (aed * rate).toFixed(2);
    const convertedAmount = toINR(orderSummaryInfo?.Payout?.TotalAmount, InrAmount.Amount);

    useEffect(() => {
        const GetAllStatusToDisplay = (serviceTypeId: number) => {
            CommonService.getWithQueryParam("master", "GetAllStatusToDisplay", 'serviceTypeId', serviceTypeId).then(response => {
                if (response.status === 200) {
                    setStatusToDisplay(response.data);
                }
            }).catch((e: string) => {
                console.log(e);
            });
        }
        GetAllStatusToDisplay(HelperConstant.serviceTypeId.SELL);
    }, []);

    useEffect(() => {
        const Inrconversion = () => {
            CommonService.get("currencyconverter", 'GetCurrencyConvertor').then(res => {
                if (res.status === 200) {
                    setInrAmount(res.data);
                }
            }).catch(e => {
                if (e == 'Request failed with status code 401') {
                    navigate('/logout')
                } else {
                    console.error("API error:", e);
                }
            })
        }
        Inrconversion();
    }, []);


    useEffect(() => {
        setOrderSummaryInfo(orderSummaryInfo)
    }, [orderSummaryInfo]);

    useEffect(() => {
        const fetchCdnUrl = async () => {
            const url = await loadConfigforImageApiUrl();
            setCdnUrl(url);
        };
        fetchCdnUrl();
    }, []);


    const unsecuredCopyToClipboard = (text: any) => {
        const textArea = document.createElement("textarea");
        textArea.value = text;
        document.body.appendChild(textArea);
        textArea.focus();
        textArea.select();
        try {
            document.execCommand('copy');
            setIsOpen(true);
            setTimeout(() => { setIsOpen(false) }, 1000);
        } catch (err) {
            console.error('Unable to copy to clipboard', err);
        }
        document.body.removeChild(textArea);
    }

    const copyHandler = (content) => {
        if (window.isSecureContext && navigator.clipboard) {
            navigator.clipboard.writeText(content);
            setIsOpen(true);
            setTimeout(() => { setIsOpen(false) }, 1000);
        } else {
            unsecuredCopyToClipboard(content);
        }
    };

    const GetStatusBadge = (status: any) => {
        switch (status) {
            case 'Assigned':
                return <Badge color="success" className="me-1 p-1 px-2 font-size-13 rounded-2">
                    {status}
                </Badge>;
            case 'Completed':
                return <Badge color="success" className="me-1 p-1 px-2 font-size-11 rounded-2">
                    {status}
                </Badge>;
            case 'Scheduled':
                return <Badge color="info" className="me-1 p-1 px-2 font-size-13 rounded-2">
                    {status}
                </Badge>;
            case 'Re-Scheduled':
                return <Badge color="primary" className="me-1 p-1 px-2 font-size-13 rounded-2">
                    {status}
                </Badge>;
            case 'Re-Quote':
                return <Badge color="warning" className="me-1 p-1 px-2 font-size-13 rounded-2">
                    {status}
                </Badge>;
            case 'Cancelled':
                return <Badge color="danger" className="me-1 p-1 px-2 font-size-13 rounded-2">
                    {status}
                </Badge>;
            case 'Failed':
                return <Badge color="danger" className="me-1 p-1 px-2 font-size-13 rounded-2">
                    {status}
                </Badge>;
            case 'Cancel Request':
                return <Badge color="danger" className="me-1 p-1 px-2 font-size-13 rounded-2">
                    {status}
                </Badge>;
            case 'Pending':
                return <Badge color="primary" className="me-1 p-1 px-2 font-size-13 rounded-2">
                    {status}
                </Badge>;
            default:
                return <Badge color="primary" className="me-1 p-1 px-2 font-size-13 rounded-2">
                    {status}
                </Badge>;
        }
    }
    return (
        <React.Fragment>
            <Row>
                <Col xl={12} className='mt-4'>
                    <Row>
                        <Col xl={4} lg={4} md={4} sm={12} xs={12} className='order-section-personal'>
                            <div>
                                <Row>
                                    {/* <Col xl={12} lg={12} md={12} sm={12} xs={12}>
                                        <h4 className="text-primary m-0">#{orderSummaryInfo?.OrderCode || ""}</h4>
                                    </Col> */}
                                    <Col xl={12} lg={12} md={12} sm={4} xs={4}>
                                        <img src={`${cdnUrl}/devicetypes/${orderSummaryInfo?.ProductTypeEnumName}.png`} alt="" className='device-summary-width m-0' />
                                    </Col>
                                    <Col xl={12} lg={12} md={12} sm={6} xs={8} className='mt-2'>
                                        <p className='m-0 mb-1 fw-semibold font-size-14'>{orderSummaryInfo?.BrandMasterName || ""}&nbsp;- {orderSummaryInfo?.SeriesModelName || ""}</p>
                                        {orderSummaryInfo?.ReferralCode ?
                                            <Badge color="warning" className="me-1 badge-soft-warning dofy-admin-font-md font-size-11">
                                                Referral Code: {orderSummaryInfo?.ReferralCode || ""}
                                            </Badge>
                                            : null
                                        }
                                        <p className='m-0 mb-1 font-size-14'>{orderSummaryInfo?.ModelVariantName || ""}</p>
                                        <Badge color="success" className="me-1 badge-soft-success font-size-13">
                                            {orderSummaryInfo?.ServiceType?.replace('a device', '') || ""}
                                        </Badge>
                                        <Badge color="primary" className="me-1 badge-soft-primary font-size-13">
                                            {orderSummaryInfo?.ProductTypeName || ""}
                                        </Badge>
                                    </Col>
                                </Row>

                            </div>


                        </Col>
                        <Col xl={4} lg={4} md={4} sm={12} xs={12} className='order-section-personal'>
                            {/* <strong className='text-info font-size-14 '>Billed To:</strong> */}
                            {/* <p  className='font-size-16 text-dofy fw-semibold'>Billed to:</p> */}
                            <div>
                                <i className="bx bxs-user check-nav-icon mt-2 mb-2 font-size-13 me-2 text-dofy"></i>
                                <span className='font-size-14 text-dofy fw-semibold'>{orderSummaryInfo?.UserName || ""}</span>
                            </div>
                            {orderSummaryInfo?.UserMobile &&
                                <div>
                                    <i className="bx bxs-phone-call check-nav-icon mt-2 mb-2 font-size-15 me-2 text-dofy"></i>
                                    <span className='font-size-14 text-dofy fw-semibold'>{countrycodenumber(orderSummaryInfo?.UserMobile)}{orderSummaryInfo?.UserMobile || ""}</span>
                                    <i className='bx bxs-copy-alt font-size-15 cursor-pointer mx-2' style={{ color: '#a6b2a9' }} onClick={() => copyHandler(OrderSummaryInfo.UserMobile)}></i>
                                </div>}
                            {orderSummaryInfo?.SecondaryMobile ?
                                <div>
                                    <i className="bx bxs-phone-call check-nav-icon mt-2 mb-2 font-size-14 me-2 text-dofy"></i>
                                    <span className='font-size-14 text-dofy fw-semibold'>{countrycodenumber(orderSummaryInfo?.SecondaryMobile)}{orderSummaryInfo?.SecondaryMobile || ""}</span>
                                    <i className='bx bxs-copy-alt font-size-15 cursor-pointer mx-2' style={{ color: '#a6b2a9' }} onClick={() => copyHandler(OrderSummaryInfo.SecondaryMobile)}></i>
                                </div> : null}
                            {isOpen && <Badge color='success' className='px-2 font-size-12'>Copied</Badge>}
                            {orderSummaryInfo?.StatusName === HelperConstant.orderStatus.PendingOrders || orderSummaryInfo?.Appointment == undefined ? <div>
                                <i className="fas fa-map-marked-alt check-nav-icon mt-2 mb-2 font-size-14 me-2 text-dofy"></i>
                                {getCountryCodeStorage() == "in" ?
                                    <>
                                        <span className='font-size-13 text-dofy fw-normal m-0'>
                                            {orderSummaryInfo?.DofyGeoName} - {orderSummaryInfo?.DofyGeoCode}
                                        </span>
                                        <p className='font-size-13 text-dofy fw-normal px-4'>{orderSummaryInfo?.DofyGeoState}</p>
                                    </>
                                    : <span className='font-size-13 text-dofy fw-normal m-0'>
                                       {orderSummaryInfo?.DofyGeoState} - {orderSummaryInfo?.DofyGeoCode}
                                    </span>}
                            </div>
                                :

                                <div>
                                    {/* <p className='font-size-16 text-dofy fw-semibold'>Address</p> */}
                                    <i className="fas fa-map-marked-alt check-nav-icon mt-2 mb-2 font-size-14 me-2 text-dofy"></i>
                                    <span className='font-size-13 text-dofy fw-normal'>  {orderSummaryInfo?.Appointment?.Address + ',' + " " || ""}
                                        {orderSummaryInfo?.Appointment?.Address1 ? (orderSummaryInfo?.Appointment?.Address1 + "," + " ") : ""}
                                        {orderSummaryInfo?.Appointment?.LandMark ? (orderSummaryInfo?.Appointment?.LandMark + "," + ' ') : ""}
                                        {orderSummaryInfo?.Appointment?.AppointmentState ? (orderSummaryInfo?.Appointment?.AppointmentState + "," + ' ') : ""}</span>
                                    <p className='font-size-13 text-dofy fw-normal m-0'> {isIn() ? (`${orderSummaryInfo?.Appointment?.AppointmentCity || ""} - ${orderSummaryInfo?.Appointment?.AppointmentPincode || ""}`) : orderSummaryInfo?.Appointment?.AppointmentPincode || ""}.</p>
                                </div>}
                            {/* {orderSummaryInfo?.StatusName === HelperConstant.orderStatus.PendingOrders || HelperConstant.orderStatus.PublicRecalculation ?
                                <div>
                                    <i className="fas fa-map-marked-alt check-nav-icon mt-2 mb-2 font-size-14 me-2 text-dofy"></i>
                                    {getCountryCodeStorage() == "in" ?
                                     <span className='font-size-13 text-dofy fw-normal m-0'>
                                     {orderSummaryInfo?.DofyGeoName} - {orderSummaryInfo?.DofyGeoCode}
                                 </span>
                                    :  <span className='font-size-13 text-dofy fw-normal m-0'>
                                     {orderSummaryInfo?.DofyGeoCode}
                                </span>}
                                   
                                </div>
                                : null} */}
                        </Col>

                        <Col xl={4} lg={4} md={4} sm={12} xs={12} className='order-section-end'>
                            <Row>
                                <Col xl={12} lg={12} md={12} sm={13} xs={12}>
                                    <div className='my-2'>
                                        {GetStatusBadge(orderSummaryInfo?.StatusName)}
                                        {orderSummaryInfo?.StatusId !== HelperConstant.StatusId.CANCEL_REQUEST ?
                                            <>
                                                {(orderSummaryInfo?.StatusName == 'Cancelled' ||orderSummaryInfo?.StatusName == 'Failed' ) && statusToDisplay?.filter((x: IStatusModel) => x.Id === orderSummaryInfo?.StatusId).map((item, index) => {
                                                    return (
                                                        <span className='m-0 font-size-12' style={{ color: `${item.ColorCode}` }}>{orderSummaryInfo?.CancellationType && `( ${orderSummaryInfo?.CancellationType} )` || ""}</span>
                                                    )
                                                })}</>
                                            : ""}
                                    </div>
                                    {!(orderSummaryInfo?.StatusName === HelperConstant.orderStatus.PendingOrders || orderSummaryInfo?.StatusName === HelperConstant.orderStatus.PublicRecalculation || orderSummaryInfo?.StatusId === HelperConstant.StatusId.ADMINCRECALCULATION) &&
                                        <div className=''>
                                            <p className='m-0 font-size-16 text-dofy fw-semibold'>{moment(orderSummaryInfo?.Appointment?.AppointmentDate).format('L') || ""} </p>
                                            <p className='m-0 font-size-16 text-dofy fw-semibold'>{moment(orderSummaryInfo?.Appointment?.StartTime).format('LT') || ""} - {moment(orderSummaryInfo?.Appointment?.EndTime).format('LT') || ""} </p>
                                        </div>}

                                </Col>
                                <Col xl={12} lg={12} md={12} sm={7} xs={7} className=''>
                                    <div className='mt-1'>
                                        {isIn() ?
                                            <>
                                                <p className='font-size-11 text-primary mb-1 fw-semibold text-muted'>Expected Cost</p>
                                                <span className='m-0 font-size-20 text-dofy fw-semibold'>{currencyByCountry(toAmount(Math.ceil(orderSummaryInfo?.Payout?.TotalAmount || "0")))}/-
                                                    <i className="bx bxs-info-circle me-2 font-size-19" onMouseEnter={() => setIsReferral(true)} onMouseLeave={() => setIsReferral(false)}></i>
                                                </span>
                                                {isReferral &&
                                                    <div className="position-relative">
                                                        <div className="order-payout-wrapper position-absolute bottom-0 orderpayout-grid">
                                                            <OrderPayout orderPayout={orderSummaryInfo} ReferralCode={orderSummaryInfo.ReferralCode} />
                                                        </div>
                                                    </div>
                                                }</>
                                            :
                                            <>
                                                <p className='font-size-11 text-primary mb-1 fw-semibold text-muted'>Expected Cost</p>
                                                <span className='m-0 font-size-20 text-dofy fw-semibold'>{currencyByCountry(toAmount(Math.ceil(orderSummaryInfo?.Payout?.TotalAmount || "0")))}/-
                                                    <i className="bx bxs-info-circle font-size-19" onMouseEnter={() => setIsReferral(true)} onMouseLeave={() => setIsReferral(false)}></i>
                                                </span>
                                                <p className='font-size-11 text-primary me-5 fw-semibold text-muted'>(₹ {convertedAmount})</p>
                                                {isReferral &&
                                                    <div className="position-relative">
                                                        <div className="order-payout-wrapper position-absolute bottom-0 orderpayout-grid">
                                                            <OrderPayout orderPayout={orderSummaryInfo} ReferralCode={orderSummaryInfo.ReferralCode} />
                                                        </div>
                                                    </div>
                                                }</>
                                        }
                                    </div>
                                </Col>
                                {!(orderSummaryInfo?.StatusName === HelperConstant.orderStatus.PendingOrders || orderSummaryInfo?.StatusName === HelperConstant.orderStatus.PublicRecalculation || orderSummaryInfo?.StatusId === HelperConstant.StatusId.ADMINCRECALCULATION) &&
                                    <Col xl={12} lg={12} md={12} sm={5} xs={5}>
                                        {showEdit && orderSummaryInfo?.StatusId !== HelperConstant.StatusId.RETURN ?
                                            <div>
                                                <Delay data={orderSummaryInfo} />
                                            </div>
                                            : null}
                                    </Col>}
                            </Row>
                        </Col>
                    </Row>
                </Col>
            </Row>
        </React.Fragment>

    )
}

export default CustomerInfo
